const WORDS = [
    "Fresas Frescas",
    "Gofres Bubble",
    "Smoothies Naturales",
    "Tú Eliges, Nosotros Creamos",
    "El Capricho Más Dulce",
];

export const Marquee = () => {
    const strip = [...WORDS, ...WORDS];
    return (
        <div
            data-testid="marquee"
            className="bg-hotpink py-4 md:py-5 overflow-hidden border-y-4 border-strawred/30"
        >
            <div className="marquee-track">
                {strip.map((w, i) => (
                    <span
                        key={i}
                        className="font-display font-semibold text-white text-2xl md:text-4xl mx-6 flex items-center"
                    >
                        {w}
                        <span className="mx-6 text-lightpink">🍓</span>
                    </span>
                ))}
            </div>
        </div>
    );
};
